import flatMap from 'flatmap';
import { useFormApi, useFormState } from 'informed';
import PropTypes from 'prop-types';

import { ButtonSubtle } from '../Buttons';

const isPlainObject = (value) =>
  typeof value === 'object' && !Array.isArray(value);

const hasTrueEntries = (value) => value === true;

const getValuesAsArray = (value) => {
  if (isPlainObject(value)) {
    const objValues = Object.values(value);
    return flatMap(objValues, getValuesAsArray);
  }

  return Array.isArray(value) ? value : [value];
};

const isChecked = (formValues) =>
  getValuesAsArray(formValues).some(hasTrueEntries);

const ResetButton = ({ children, onReset }) => {
  const { reset } = useFormApi();
  const { values } = useFormState();

  // As of informed@3.9, `onValueChange` is no longer fired when `reset` is called.
  // Instead, we expose a callback that is invoked with the new form values after reset.
  const handleClick = () => {
    reset();
    onReset(values);
  };

  return (
    <ButtonSubtle
      className="button-subtle dt-button"
      disabled={!isChecked(values)}
      onClick={handleClick}
    >
      {children}
    </ButtonSubtle>
  );
};

ResetButton.defaultProps = {
  onReset: () => {},
};

ResetButton.propTypes = {
  children: PropTypes.string.isRequired,
  onReset: PropTypes.func,
};

export default ResetButton;
